import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { App } from './App.js';
import { RouteLogger } from './components/RouteLogger.js';
import { logBuildInfo } from './lib/build-info.js';
import './styles/index.css';

const container = document.getElementById('root');
if (!container) throw new Error('Root container missing');

// #430 — log the deployed build/commit + the URL the app loaded at (the build
// also shows on the PTSB logo hover tooltip). RouteLogger below logs each route.
logBuildInfo();

createRoot(container).render(
  <React.StrictMode>
    <BrowserRouter>
      <RouteLogger />
      <App />
    </BrowserRouter>
  </React.StrictMode>,
);
